import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { Button } from './Button';
import { scrollToCompra } from '../utils/scroll';
export function ProductShowcase() {
  const tomos = [{
    icon: '📘',
    title: 'Tomo 1 — El Origen del Asombro (Lógica y Gnoseología)',
    desc: 'Cómo enseñar a pensar en la era de la post-verdad. De los Presocráticos al análisis de fake news. Lógica aplicada a redes sociales y el método socrático para "debunkear" desinformación. El tomo que transforma el pensamiento abstracto en una herramienta de supervivencia digital.'
  }, {
    icon: '📗',
    title: 'Tomo 2 — El Animal Político (Poder y Ciudadanía)',
    desc: 'El contrato social explicado para el siglo XXI. De Maquiavelo y Hobbes al panóptico digital de Foucault e Instagram. Cómo funciona el poder, los derechos humanos de cuarta generación y la ciudadanía en un mundo globalizado.'
  }, {
    icon: '📙',
    title: 'Tomo 3 — El Espejo Humano (Antropología y Existencialismo)',
    desc: '¿Qué nos hace humanos? El sentido de la vida según Sartre, Camus y la IA. Un recorrido profundo y dinámico sobre la identidad, la angustia y la libertad, diseñado para conectar con las crisis existenciales propias de la adolescencia.'
  }, {
    icon: '📕',
    title: 'Tomo 4 — Brújula Ética (Ética y Moral)',
    desc: 'Dilemas morales que sí importan. Bioética, ética ambiental y la responsabilidad en el uso de la tecnología. No les enseñamos qué pensar, sino cómo decidir frente a los problemas reales de 2026.'
  }, {
    icon: '📓',
    title: 'Tomo 5 — La Ciencia en la Mira (Epistemología)',
    desc: '¿Cómo sabemos lo que sabemos? El método científico vs. las pseudociencias. Un análisis crítico sobre el conocimiento, la verdad y el impacto de la ciencia en nuestra vida cotidiana.'
  }, {
    icon: '📔',
    title: 'Tomo 6 — Mundos Posibles (Estética y Metafísica)',
    desc: '¿Qué es la belleza hoy? Del arte clásico a la cultura de masas y la realidad virtual. Relectura del mito de la caverna aplicado al metaverso y las pantallas. El cierre perfecto para que el alumno entienda que la realidad es mucho más de lo que ve.'
  }];
  return <section className="py-5 md:py-6 px-4 bg-brand-cardAlt border-y border-brand-accent/10" data-id="element-122">
      <div className="max-w-5xl mx-auto" data-id="element-123">
        <div className="text-center mb-5" data-id="element-124">
          <h2 className="text-sm md:text-lg font-black text-white mb-2 leading-tight uppercase" data-id="element-125">
            🏆 El sistema más completo de planificación para docentes de
            Filosofía de habla hispana
          </h2>
          <p className="text-xl md:text-3xl font-black text-brand-accent neon-glow mb-2 uppercase" data-id="element-126">
            📜 KIT COMPLETO FILOSOFÍA LISTA
          </p>
          <p className="text-xs md:text-sm text-gray-300 font-bold max-w-2xl mx-auto" data-id="element-127">
            6 tomos organizados por núcleos temáticos. 120+ secuencias
            didácticas completas. 4 bonos estratégicos. Todo listo para usar
            desde hoy.
          </p>
        </div>

        <h3 className="text-center text-white font-black mb-4 text-sm md:text-base uppercase bg-brand-accent/10 py-2 rounded-lg border border-brand-accent/30" data-id="element-128">
          📘 LOS 6 TOMOS MAESTROS (360 PÁGINAS DE VALOR)
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4 mb-5" data-id="element-129">
          {tomos.map((tomo, i) => <div key={i} className="bg-brand-card border border-brand-accent/20 rounded-lg p-4 hover:border-brand-accent/60 transition-colors group shadow-[0_4px_15px_rgba(0,0,0,0.5)]" data-id="element-130">
              <h4 className="text-sm md:text-base font-black text-white mb-2 flex items-start group-hover:text-brand-accent transition-colors leading-tight" data-id="element-131">
                <span className="text-lg mr-2 leading-none" data-id="element-132">{tomo.icon}</span>
                <span data-id="element-133">{tomo.title}</span>
              </h4>
              <p className="text-[11px] md:text-xs text-gray-400 leading-relaxed font-bold ml-7" data-id="element-134">
                {tomo.desc}
              </p>
            </div>)}
        </div>

        <div className="w-full max-w-md mx-auto text-center mt-6" data-id="element-135">
          <Button onClick={scrollToCompra} className="text-sm md:text-base py-3 md:py-4 shadow-[0_0_30px_rgba(0,255,136,0.4)] w-full" data-id="element-136">
            🔥 QUIERO DEJAR DE IMPROVISAR — VER OFERTA
          </Button>
        </div>
      </div>
    </section>;
}